import { render, staticRenderFns } from "./CMSDeployHistory.vue?vue&type=template&id=13883179&"
import script from "./CMSDeployHistory.vue?vue&type=script&lang=js&"
export * from "./CMSDeployHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports